import { useEffect, useReducer, useRef, useState } from "react";
import { Button, ButtonGroup, FormLabel } from "react-bootstrap";
import { useProfile } from "../components/ProfileContext";
import { SimpleFormField } from "../components/SimpleFormField";
import { SpinnerButton } from "../components/SpinnerButton";
import { versionNumber } from "../dependencies";
import { User } from "../models/User";
import { Api } from "../util/Api";
import { afterRenderDelay, blobToDataUrl, getRandomId, setNavAdvisoryLockout, uncacheUrl } from "../util/utils";

export function SettingsPage(props) {
	setNavAdvisoryLockout(false);

	let [logoLoadNumber, setLogoLoadNumber] = useState(getRandomId());
	let [profile, setProfile] = useProfile();
	let [currentInspectorIdentifier, setCurrentInspectorIdentifier] = useState(profile.inspectorIdentifier);
	let [fullName, setFullName] = useState(null);
	let [mcidErrorText, setMcidErrorText] = useState(null);
	let [isReloading, setIsReloading] = useState(false);
	let [hasLogo, setHasLogo] = useState(true);
	let isVerified = (!!currentInspectorIdentifier) && currentInspectorIdentifier == profile.inspectorIdentifier;
	let uploadRef = useRef();

	let logoUrl = Api.forProfile(profile).getUserLogoUrl(profile.id, true);

	let makeRentalModeAction = (isOn) => () => {
		let newProfile = new User();
		Object.assign(newProfile, profile);
		newProfile.rentalMode = isOn;
		setProfile(newProfile);
		User.saveUser(newProfile);		
	};

	let uploadLogoAction = async () => {
		let file = uploadRef.current.files[0];
		if(!file) {
			alert("No logo file specified");
			return;
		}

		let logoData = await blobToDataUrl(file);
		await Api.forProfile(profile).uploadUserLogo(logoData);
		setLogoLoadNumber(getRandomId());
		await uncacheUrl(logoUrl);
		alert("Logo updated");
	};

	let checkMcElroyId = async (newInspectorIdentifier) => {
		if(!newInspectorIdentifier) {
			// Blank values will always work to remove the Inspector
			profile.inspectorIdentifier = null;
			setCurrentInspectorIdentifier(null);
			return;
		}
		if(!navigator.onLine) {
			alert("Cannot change McElroy ID when offline.")
		}
		try {
			let details = await Api.verifyMcElroyId(newInspectorIdentifier);
			profile.loadInspectorDetails(details);
			setProfile(profile);
			await User.saveUser(profile);
			setCurrentInspectorIdentifier(details.mcid);
			setFullName(profile.inspectorName)
			setMcidErrorText(null);
		} catch(err) {
			setCurrentInspectorIdentifier(newInspectorIdentifier);
			setMcidErrorText(err);
			console.log(err);
			// Invalid MCID - do nothing
		}
	};

	let mcelroyIdChanged = async (evt) => {
		let newInspectorIdentifier = evt.target.value;
		await checkMcElroyId(newInspectorIdentifier);
	};

	useEffect(() => {
		// First run, verify mcelroy ID to get the user's name
		if(navigator.onLine) {
			checkMcElroyId(currentInspectorIdentifier)
		}	
	}, []);

	useEffect(async () => {
		let possiblyMissingLogo = Api.forProfile(profile).getUserLogoUrl(profile.id, false);
		let result = await uncacheUrl(possiblyMissingLogo);
		setHasLogo(result.status != 404);
	});

	let reloadBrowser = () => {
		setIsReloading(true);

		afterRenderDelay(async () => {
			// Get base URL without path
			let url = window.location.href.split("#")[0];

			// Force the browser to get an uncached copy
			await uncacheUrl(url);

			window.location.href = url;
		});
	};

	return <div className="settingsContainer">
		<h1>Device Settings</h1>
		<FormLabel>Inspection Mode</FormLabel><br />
		<ButtonGroup>
			<button onClick={makeRentalModeAction(false)}  className={!profile.rentalMode ? "button" : "disabled_button"}>Maintenance</button>
			<button onClick={makeRentalModeAction(true)}  className={profile.rentalMode ? "button" : "disabled_button"}>Rental</button>
		</ButtonGroup>

		<div className="error-info">
			{mcidErrorText}&nbsp;
		</div>
		<SimpleFormField className="mt-4" scannable={true} label={`Inspector McElroy ID ${!isVerified ? "(unverified)" : ""}${isVerified && !!fullName ? "(" + fullName + ")" : ""}`} onChange={mcelroyIdChanged} defaultValue={currentInspectorIdentifier} />

		<hr className="my-4" />

		<p>
			<FormLabel>Version:&nbsp;</FormLabel>
			{versionNumber}
		</p>

		<h1>User Settings</h1>

		<p>{hasLogo ? "Current logo" : "No logo uploaded"}</p>
		<img src={logoUrl + "?_=" + logoLoadNumber} style={{maxWidth: "100%"}} />

		<p className="mt-4">{hasLogo ? "Replace Logo" : "Set Logo"} (PNG or JPEG):</p>
		<p><input type="file" ref={uploadRef} accept=".png,.jpg,.jpeg,.gif" className="mb-4" /> <Button onClick={uploadLogoAction}>Upload</Button></p>

		{false && <>
		{navigator.onLine && <>
			<SpinnerButton spinning={isReloading} onClick={reloadBrowser}>Load App Updates</SpinnerButton>
		</>}
		</>}
	</div>;
}